import { TranslationKey } from "../i18n/translation-key"
import { JobStatus } from "./job"

const JOB_STATUS_LABEL_KEYS: Record<JobStatus, TranslationKey> = {
  [JobStatus.CANCELLED]: "common.jobStatus.cancelled",
  [JobStatus.BOOKED]: "common.jobStatus.booked",
  [JobStatus.CHECKED_IN]: "common.jobStatus.checkedIn",
  [JobStatus.COLLECTED]: "common.jobStatus.collected",
  [JobStatus.INSPECTION_DRAFT_SAVED]: "common.jobStatus.inspectionDraftSaved",
  [JobStatus.SERVICE_PROPOSAL_SENT]: "common.jobStatus.serviceProposalSent",
  [JobStatus.SERVICE_PROPOSAL_ACCEPTED]:
    "common.jobStatus.serviceProposalAccepted",
  [JobStatus.COMPLETED]: "common.jobStatus.completed",
  [JobStatus.DELIVERED]: "common.jobStatus.delivered",
}

export class JobStatusMapper {
  static toLabelKey(status: JobStatus): TranslationKey {
    return JOB_STATUS_LABEL_KEYS[status]
  }
}
